import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { TuiSizeL } from '@taiga-ui/core';
import { TranslateService } from '@ngx-translate/core';
import { OrganisationService } from '@src/core/services';
import { BaseResizableComponent } from '@src/app/modules/base';

import { LoyaltyProgramListProduct } from '../../models';

@Component({
  selector: 'lp-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductCardComponent extends BaseResizableComponent {
  private readonly translateService = inject(TranslateService);
  private readonly organisationService = inject(OrganisationService);

  @Input() product?: LoyaltyProgramListProduct;
  @Input() collectionId?: string;
  @Input() ref?: string;
  @Input() loading = false;
  @Input() showIsFavorite = false;
  @Input() showDiscount = true;
  @Input() size: TuiSizeL = 'l';

  /** Признак использования unionId в запросах */
  private useUnionId = false;

  /** ID ассоциации внешней базы */
  get externalUnionId(): string | undefined {
    return this.useUnionId ? this.product?.unionId : undefined;
  }

  get status() {
    return this.product?.status;
  }

  get discountText() {
    return this.product?.discountText;
  }

  get coverImgId() {
    return this.product?.coverImageId;
  }

  get isNew() {
    return !!this.product?.isNew;
  }

  get isArchive() {
    return this.status === 'archive';
  }

  get isReview() {
    return this.status === 'review';
  }

  get statusText() {
    if (this.isNew) {
      return this.translateService.instant('components.loyaltyProductCard.labels.statusNew');
    }

    switch (this.status) {
      case 'archive':
        return this.translateService.instant('components.loyaltyProductCard.labels.statusArchive');
      case 'review':
        return this.translateService.instant('components.loyaltyProductCard.labels.statusReview');
      default:
        return null;
    }
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.organisationService.currentParentOrganisation$.subscribe(() => {
      this.setUseUnionId();
    });
  }

  /** Заполняем признак использования unionId */
  setUseUnionId() {
    this.useUnionId = this.product?.unionId
      ? this.organisationService.currentParentOrganisation$.value?.id !== this.product.unionId
      : false;
  }
}
